var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeasonTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.25 38.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.4,1.25v36c0,.15-.1.25-.25.25h-3.4c-.15,0-.25-.1-.25-.25V6.2l-11.5,31.1c-.05.1-.15.2-.25.2h-3.05c-.1,0-.2-.1-.25-.2L3.9,6.2v31.05c0,.15-.1.25-.25.25H.25c-.15,0-.25-.1-.25-.25V1.25c0-.15.1-.25.25-.25h5.15c.1,0,.2.1.25.2l11.7,31.15L28.8,1.2c.05-.1.15-.2.25-.2h5.1c.15,0,.25.1.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.3,38.45c-10.9,0-17-8.3-17-19.15S50.35,0,61.15,0s17.2,8.3,17.2,19.3-6.05,19.15-17.05,19.15ZM61.35,35.05c8.8,0,13.1-6.85,13.1-15.75s-4.4-15.9-13.2-15.9-13.05,7.05-13.05,15.9,4.1,15.75,13.15,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.8,1.3l-9.4,36c-.05.15-.1.2-.25.2h-3.75c-.15,0-.2-.1-.25-.2l-7-26.55-1.15-4.55-8.2,31.1c-.05.1-.1.2-.25.2h-3.75c-.15,0-.2-.05-.25-.2L85.3,1.3c-.05-.2.1-.3.25-.3h3.35c.15,0,.2.05.25.2l6.55,26.45,1,3.95,1.05-3.95,7.15-26.45c.05-.1.1-.2.25-.2h3.8c.15,0,.2.05.25.2l8,30.45,7.65-30.45c.05-.15.1-.2.25-.2h3.45c.15,0,.3.1.25.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.45,11.7c-1.15-5.2-5.8-8.3-11.05-8.3-9.65,0-13.25,7.2-13.25,17,0,8,4.8,14.65,12.8,14.65,7.85-.05,12.2-5.65,12.15-13.25h-11.9c-.15,0-.25-.1-.25-.25v-2.9c0-.15.1-.25.25-.25h15.45c.15,0,.25.1.25.25v18.6c0,.15-.1.25-.25.25h-2.95c-.15,0-.25-.1-.25-.25v-5.25c-2.7,4.2-6.75,6.45-13.2,6.45-10.7,0-16-8.3-16-19.4S141.05,0,152.15,0c4.45,0,8.3,1.3,11.05,3.8,2.05,1.85,3.65,4.45,4.25,7.85.05.15-.05.25-.2.25h-3.5c-.15,0-.25-.05-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.4,1.25v32.85h19.05c.15,0,.25.1.25.25v2.9c0,.15-.1.25-.25.25h-22.7c-.15,0-.25-.1-.25-.25V1.25c0-.15.1-.25.25-.25h3.4c.15,0,.25.1.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.6,1h3.4c.15,0,.25.1.25.25v36c0,.15-.1.25-.25.25h-3.4c-.15,0-.25-.1-.25-.25V1.25c0-.15.1-.25.25-.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonTitle);
export default __webpack_public_path__ + "static/media/season_title.f66d84df4d5c1694687faffac1387adc.svg";
export { ForwardRef as ReactComponent };